export const displayConfirmationLeavingSpotSelector = ({displayConfirmationLeavingSpot}) => displayConfirmationLeavingSpot